import { FicheContainer, useFiche } from '@mairistem/fiche';
import { isNil } from 'lodash';
import React from 'react';
import SubventionFicheConsumer from '@/src/components/SubventionFiche/SubventionFicheConsumer';
import SubventionFicheBarConsumer, {
	handleCreatingFicheSubvention,
} from './SubventionFicheBarConsumer';

const handleUrl = (method: string, data) => {
	const { identifiant } = data;

	switch (method) {
		case 'get':
			return `/api/finances/subventionsPercues/${identifiant}?modeEtendu=true`;
		case 'put':
		case 'delete':
			return `/api/finances/subventionsPercues/${identifiant}`;
		default:
			return '/api/finances/subventionsPercues/';
	}
};

const SubventionFiche = () => {
	const [subventionService] = useFiche(handleUrl);

	const handleValidate = ({
		libelle = null,
		identifiantProjet = null,
		identifiantFinanceur = null,
	}) => {
		const errors = [];
		if (isNil(libelle) || libelle.length === 0) {
			errors.push({
				id: 'subventionsPercues-libelle',
				message: 'Le libellé de la subvention est obligatoire',
			});
		}

		if (isNil(identifiantProjet) || identifiantProjet === 0) {
			errors.push({
				id: 'subventionsPercues-identifiantProjet',
				message: 'Le projet de la subvention est obligatoire',
			});
		}

		if (isNil(identifiantFinanceur) || identifiantFinanceur === 0) {
			errors.push({
				id: 'subventionsPercues.identifiantFinanceur',
				message: 'Le financeur de la subvention est obligatoire',
			});
		}

		return errors;
	};

	const handleApiError = (errors) => {
		if (errors?.status >= 500) {
			return {
				message: 'Une erreur technique est survenue',
			};
		}

		return errors?.response?.data.map((error) => ({
			id: error?.id || null,
			message: error?.message,
		}));
	};

	return (
		<FicheContainer
			type="subvention"
			service={subventionService}
			/* @ts-expect-error */
			onValidate={handleValidate}
			onApiError={handleApiError}
			hasHistory={false}
			onCreating={handleCreatingFicheSubvention}
		>
			{(props) => (
				<>
					<SubventionFicheBarConsumer {...props} />
					<SubventionFicheConsumer {...props} />
				</>
			)}
		</FicheContainer>
	);
};

export default SubventionFiche;
